export class ProductReason {
    constructor(reasonId, reasonText) {
        this.reasonId = reasonId;
        this.reasonText = reasonText;
    }
}